import { styled, Stack } from '@mui/material';

const Container = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile?: boolean | null }>(({ isMobile }) => ({
  padding: '8px 16px',
  height: 52,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  ...(!isMobile && {
    '&:hover': {
      '> div:last-child': {
        opacity: 1,
      },
    },
  }),
}));

const Box = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile?: boolean | null }>(({ isMobile }) => ({
  padding: 0,
  flexDirection: 'row',
  gap: 8,
  alignItems: 'center',
  ...(!isMobile && { opacity: 0, transition: 'opacity 0.3s ease' }),
}));

export { Container, Box };
